<template>
  <div class="Cart">
    <div class="title">
      常购清单
      <el-button type="primary" plain @click="addGroup">新增分组</el-button>
    </div>
    <div v-if="regularPurchaseList.length > 0">
      <div class="cartTableHeader">
        <span> </span>
        <span>商品信息</span>
        <span>单价</span>
        <span>单位</span>
        <span>数量</span>
        <span>操作</span>
      </div>
      <ul class="group" v-for="(order, idx) in regularPurchaseList" :key="idx">
        <div class="group_title">
          <div>{{ order.izclrsecwsxu9yfg }}</div>
          <div @click="delGroup(order)">删除</div>
        </div>
        <li v-for="(item, index) in order.vil3pydur6d8qauy" :key="index">
          <div class="orderDetail">
            <el-checkbox v-model="item.checked"></el-checkbox>
            <img
              :src="
                item['mnkt8dkjryhvdej3'] && item['mnkt8dkjryhvdej3'].length > 0
                  ? item['mnkt8dkjryhvdej3'][0].url
                  : ''
              "
              alt="商品图片"
            />
            <div class="goodsName">
              <p
                @click="navTo('/mall/goods/' + item.whfmbyuc1i2pavi4[0].id)"
                v-if="item.whfmbyuc1i2pavi4 && item.whfmbyuc1i2pavi4.length > 0"
              >
                {{ item.whfmbyuc1i2pavi4[0].value }}
              </p>
              <!-- <span>{{ item.goods.spec }}</span> -->
            </div>

            <span class="unitPrice">
              {{ item.t9rtdu9o7iztvayy ? '￥' + item.t9rtdu9o7iztvayy : 0 }}
            </span>
            <span class="unitPrice">
              {{ item.kq1qbbk7dulmlghs }}
            </span>
            <span class="num">
              <NumberInput
                @changeHandle="numberChange(item, order.id)"
                :initNum="item.mcuilzaudpe3shlc"
                v-model="item.mcuilzaudpe3shlc"
                :min="1"
                :max="99"
              />
            </span>
            <!-- <input @change="numberChange(item.id)" type="text" v-model="item.temGoodsNum" min="1" class="numInput" /> -->
            <!-- <span class="amount">{{ "￥" + item.amount }}</span> -->
            <!-- <button @click="deleteOrder(item.id)">
             删除
            </button> -->
            <span @click="deleteOrder(item.id)">
              <img src="../../assets/img/del.svg" alt="" class="icon" />
            </span>
          </div>
        </li>
      </ul>
      <div class="cartFooter">
        <!-- <span>应付金额：</span> -->
        <!-- <span class="total">{{ '￥' + totalAmount }}</span> -->
        <button @click="settleAccounts">下单</button>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/cart.svg" alt="" />
    </p>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import NumberInput from "../../components/NumberInput";
import {
  online,
  delOnline,
  updateOnline,
  children,
  postOnline,
} from "@/api/platform";
export default {
  name: "Cart",
  components: {
    NumberInput,
  },
  computed: {
    // totalAmount () {
    //   let amount = 0;
    //   this.orderList.map((item, index) => {
    //     amount += item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj;
    //   });
    //   return amount;
    // },
  },
  data () {
    return {
      form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
      order: {},
      regularPurchaseList: [],
      checkAll: false,
      isIndeterminate: false,
    };
  },
  created () {
  },
  mounted () {
    this.getRegularPurchaseList();
  },
  methods: {
    // 新增分组
    addGroup () {
      this.$prompt('分组名称', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        if (value) {
          await postOnline({
            form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
            izclrsecwsxu9yfg: value,
          })
          this.$message({
            type: 'success',
            message: '创建成功'
          });
          this.getRegularPurchaseList();
        }
      })
    },
    delGroup ({ id }) {
      this.$confirm('是否确认删除该分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delOnline({
          form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
          ids: [id]
        })
        this.getRegularPurchaseList()
      })
    },
    // 获取订单列表
    async getRegularPurchaseList () {
      const { form_head_uuid } = this;
      const { result } = await online({
        form_head_uuid,
        page: 1,
        limit: 1000,
        keyword: "",
        select_option: "",
      });
      let list = await Promise.all(
        result.map(async (el) => ({
          ...el,
          vil3pydur6d8qauy: await this.children(el.id),
        }))
      );
      this.regularPurchaseList = list;
    },
    // 获取子表数据
    async children (record_id) {
      const { form_head_uuid } = this;
      const { result } = await children({
        page: 1,
        limit: 100,
        field_uuid: "2190d51416b84722902efd1a5ee39dca",
        form_head_uuid,
        record_id,
      });
      return result.map(el => ({ ...el, checked: false }));
    },
    // 数量切换
    async numberChange (item, id) {
      let obj = JSON.parse(JSON.stringify(item))
      delete obj.checked;
      obj.mnkt8dkjryhvdej3 = obj.mnkt8dkjryhvdej3.map(el => el.id)
      obj.whfmbyuc1i2pavi4 = obj.whfmbyuc1i2pavi4.map(el => el.id)
      const { form_head_uuid } = this;
      await updateOnline({
        id,
        form_head_uuid,
        vil3pydur6d8qauy: [obj]
      });
    },
    // 删除常购清单
    async deleteOrder (orderId) {
      const { form_head_uuid } = this;
      await delOnline({
        form_head_uuid: 'd833435e05c511ef80bc0242321230b4',
        ids: [orderId],
      });
      this.getRegularPurchaseList();
    },
    navTo (route) {
      this.$router.push(route);
    },
    async settleAccounts () {
      const commodityList = this.regularPurchaseList.reduce((accumulator, el) => {
        const checkedItems = el.vil3pydur6d8qauy.filter(item => item.checked);
        return accumulator.concat(checkedItems);
      }, []);
      if (commodityList.length === 0) {
        return this.$notify.error({
          title: '提示',
          message: '您还没有选择商品'
        });
      }
      this.$store.commit('setData', {
        commodityList,
      });
      this.$router.push('/mall/createOrder?form=regularPurchaseList')
    },
  },

};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.Cart {
  width: 100%;
  height: 100%;
  background: #fff;
  display: block;
  padding: 30px 0;
  .title {
    height: 18px;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    border-left: 4px solid #de531d;
    padding-left: 10px;
    line-height: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .emptyTips {
    // width: 200px;
    text-align: center;
    margin: 200px auto;
  }
  .cartTableHeader {
    width: 100%;
    height: 40px;
    background-color: #fafafa;
    border: 1px solid @borderColor;
    color: #666;
    font-size: 14px;
    line-height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      display: inline-block;
      width: 160px;
      text-align: center;
      line-height: 40px;
      &:first-child {
        width: 60px;
        text-align: center;
      }
      &:nth-child(2) {
        width: 500px;
      }
    }
  }
  .group {
    width: 100%;
    .group_title {
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        &:first-child {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }
        &:last-child {
          font-size: 12px;
          color: #666;
          cursor: pointer;
        }
      }
    }
    li {
      border: 1px solid @borderColor;
      border-bottom: 0;
      font-size: 13px;
      &:last-child {
        border-bottom: 1px solid @borderColor;
      }
      .orderHeader {
        background-color: #f1f1f1;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        .orderTime {
          font-weight: 600;
        }
        .orderId,
        .state {
          margin-left: 10px;
        }
      }
      .orderDetail {
        width: 100%;
        height: 100%;
        padding: 20px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;
        .el-checkbox {
          width: 60px;
          text-align: center;
        }
        img {
          width: 80px;
          height: 80px;
          display: inline-block;
        }
        .goodsName {
          width: 480px;
          vertical-align: top;
          height: 84px;
          font-size: 14px;
          padding-left: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          span {
            color: @fontDefaultColor;
            display: block;
            margin-top: 10px;
          }
        }
        .unitPrice,
        .num,
        .amount {
          flex-shrink: 0;
          display: inline-block;
          vertical-align: top;
          width: 160px;
          height: 85px;
          line-height: 85px;
          text-align: center;
          display: flex;
          justify-content: center;
        }
        .NumberInput {
          position: relative;
          top: 25px;
          /deep/span {
            color: #666;
          }
        }
        button {
          position: absolute;
          right: 20px;
          bottom: 40px;
          width: 70px;
          height: 30px;
          border-radius: 3px;
          background-color: @falseColor;
          color: white;
          border: none;
        }
        span {
          cursor: pointer;
          &:last-child {
            width: 180px;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
  .cartFooter {
    width: 100%;
    height: 70px;
    line-height: 70px;
    padding: 0 10px;
    border: 1px solid @borderColor;
    border-top: none;
    background-color: #fafafa;
    position: relative;
    span {
      color: @fontDefaultColor;
      display: inline-block;
      vertical-align: top;
    }
    .total {
      color: @falseColor;
      font-size: 25px;
      font-weight: 600;
    }
    button {
      position: absolute;
      right: 0;
      top: 0;
      width: 150px;
      height: 100%;
      background-color: @thirdColor;
      border: none;
      color: white;
      font-size: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/RegularPurchaseList.vue